/**
 * @generated SignedSource<<e6836c57020a2c6f4d801555173a25db>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TeamScheduleNewQuery$variables = {
  teamId: string;
};
export type TeamScheduleNewQuery$data = {
  readonly store: {
    readonly id: string;
    readonly team: {
      readonly color: string | null;
      readonly " $fragmentSpreads": FragmentRefs<"TeamScheduleComponent_team">;
    } | null;
  };
};
export type TeamScheduleNewQuery = {
  response: TeamScheduleNewQuery$data;
  variables: TeamScheduleNewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "teamId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "teamId"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
},
v4 = {
  "kind": "Literal",
  "name": "freq",
  "value": "DAILY"
},
v5 = {
  "kind": "Literal",
  "name": "movePeriod",
  "value": -1
},
v6 = [
  (v1/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "notCompletedCount",
    "storageKey": null
  }
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isActive",
  "storageKey": null
},
v8 = [
  {
    "kind": "Literal",
    "name": "includeInlineRoutines",
    "value": true
  }
],
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startAt",
  "storageKey": null
},
v11 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isTeamScheduleEventOccasion"
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isLinkedToViewer",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "workStatus",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "thumbhash",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "urlExpiresAt",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "height",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "width",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "image",
  "plural": false,
  "selections": [
    (v9/*: any*/),
    {
      "kind": "TypeDiscriminator",
      "abstractKey": "__isPublicAndInternalImage"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "publicImageUrl",
          "storageKey": null
        }
      ],
      "type": "PublicImage",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v1/*: any*/),
        (v16/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "ImageSize",
          "kind": "LinkedField",
          "name": "sizes",
          "plural": true,
          "selections": [
            (v1/*: any*/),
            (v17/*: any*/),
            (v18/*: any*/),
            (v19/*: any*/),
            (v20/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "type": "Image",
      "abstractKey": null
    }
  ],
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "concreteType": "AssignedEmployee",
  "kind": "LinkedField",
  "name": "assigned",
  "plural": true,
  "selections": [
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Employee",
      "kind": "LinkedField",
      "name": "employee",
      "plural": false,
      "selections": [
        (v1/*: any*/),
        (v13/*: any*/),
        (v14/*: any*/),
        (v15/*: any*/),
        (v21/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "assignedAt",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v23 = [
  (v1/*: any*/)
],
v24 = {
  "alias": null,
  "args": null,
  "concreteType": "AssignedRole",
  "kind": "LinkedField",
  "name": "assignedRoles",
  "plural": true,
  "selections": [
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "EmployeeRole",
      "kind": "LinkedField",
      "name": "role",
      "plural": false,
      "selections": [
        (v1/*: any*/),
        (v14/*: any*/),
        (v13/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "employeeIds",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Team",
          "kind": "LinkedField",
          "name": "team",
          "plural": false,
          "selections": (v23/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Employee",
          "kind": "LinkedField",
          "name": "employees",
          "plural": true,
          "selections": [
            (v1/*: any*/),
            (v14/*: any*/),
            (v13/*: any*/),
            (v15/*: any*/),
            (v21/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v25 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "style",
        "value": "TIME_ONLY"
      }
    ],
    "kind": "ScalarField",
    "name": "storeFormattedDate",
    "storageKey": "storeFormattedDate(style:\"TIME_ONLY\")"
  }
],
v26 = {
  "alias": null,
  "args": null,
  "concreteType": "StoreZonedDate",
  "kind": "LinkedField",
  "name": "startAtDate",
  "plural": false,
  "selections": (v25/*: any*/),
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "concreteType": "StoreZonedDate",
  "kind": "LinkedField",
  "name": "deadlineAtDate",
  "plural": false,
  "selections": (v25/*: any*/),
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sequenceNumber",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "completedTaskExecutionCount",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalTaskExecutionCount",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "calculateNoTasks",
      "value": true
    },
    {
      "kind": "Literal",
      "name": "calculateNotCompletedStarted",
      "value": true
    }
  ],
  "kind": "ScalarField",
  "name": "status",
  "storageKey": "status(calculateNoTasks:true,calculateNotCompletedStarted:true)"
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deadlineAt",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "issueCount",
  "storageKey": null
},
v34 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isScheduledOccasion"
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isOrg",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "orgIconUri",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isArchived",
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "concreteType": "ImageSize",
  "kind": "LinkedField",
  "name": "sizes",
  "plural": true,
  "selections": [
    (v19/*: any*/),
    (v20/*: any*/),
    (v1/*: any*/),
    (v17/*: any*/),
    (v18/*: any*/)
  ],
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "concreteType": "File",
  "kind": "LinkedField",
  "name": "descriptionFiles",
  "plural": true,
  "selections": [
    (v1/*: any*/),
    (v17/*: any*/),
    (v14/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    (v36/*: any*/)
  ],
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "concreteType": "TaskExecutionCheck",
  "kind": "LinkedField",
  "name": "taskExecution",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "RoutineOccasion",
      "kind": "LinkedField",
      "name": "routineOccasion",
      "plural": false,
      "selections": [
        (v9/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Routine",
          "kind": "LinkedField",
          "name": "routine",
          "plural": false,
          "selections": [
            (v12/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "Image",
              "kind": "LinkedField",
              "name": "descriptionImages",
              "plural": true,
              "selections": [
                (v9/*: any*/),
                (v1/*: any*/)
              ],
              "storageKey": null
            },
            (v1/*: any*/)
          ],
          "storageKey": null
        },
        (v22/*: any*/),
        (v24/*: any*/),
        (v1/*: any*/),
        (v26/*: any*/),
        (v27/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Store",
          "kind": "LinkedField",
          "name": "store",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "myRole",
              "storageKey": null
            },
            (v1/*: any*/)
          ],
          "storageKey": null
        },
        (v28/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "notDoneStatus",
          "storageKey": null
        },
        (v29/*: any*/),
        (v30/*: any*/),
        (v31/*: any*/),
        (v32/*: any*/),
        (v10/*: any*/),
        (v33/*: any*/),
        (v34/*: any*/)
      ],
      "storageKey": null
    },
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "TaskCheck",
      "kind": "LinkedField",
      "name": "task",
      "plural": false,
      "selections": (v23/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sectionId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Routine",
      "kind": "LinkedField",
      "name": "routine",
      "plural": false,
      "selections": [
        (v1/*: any*/),
        (v35/*: any*/),
        (v36/*: any*/),
        (v12/*: any*/),
        (v37/*: any*/),
        (v38/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Image",
          "kind": "LinkedField",
          "name": "descriptionImages",
          "plural": true,
          "selections": [
            (v1/*: any*/),
            (v39/*: any*/),
            (v16/*: any*/),
            (v9/*: any*/)
          ],
          "storageKey": null
        },
        (v40/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "checkValue",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "concreteType": "Routine",
  "kind": "LinkedField",
  "name": "routine",
  "plural": false,
  "selections": [
    (v12/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "descriptionImages",
      "plural": true,
      "selections": [
        (v9/*: any*/),
        (v1/*: any*/),
        (v39/*: any*/),
        (v16/*: any*/)
      ],
      "storageKey": null
    },
    (v1/*: any*/),
    (v35/*: any*/),
    (v36/*: any*/),
    (v37/*: any*/),
    (v38/*: any*/),
    (v40/*: any*/)
  ],
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "expireAt",
  "storageKey": null
},
v44 = {
  "kind": "InlineFragment",
  "selections": [
    (v26/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "StoreZonedDate",
      "kind": "LinkedField",
      "name": "endAtDate",
      "plural": false,
      "selections": (v25/*: any*/),
      "storageKey": null
    }
  ],
  "type": "TeamScheduleOneOffEvent",
  "abstractKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v46 = {
  "kind": "Literal",
  "name": "freq",
  "value": "WEEKLY"
},
v47 = [
  (v1/*: any*/),
  (v7/*: any*/),
  {
    "alias": null,
    "args": (v8/*: any*/),
    "concreteType": null,
    "kind": "LinkedField",
    "name": "events",
    "plural": true,
    "selections": [
      (v9/*: any*/),
      (v1/*: any*/),
      (v11/*: any*/),
      {
        "kind": "InlineFragment",
        "selections": [
          (v41/*: any*/),
          (v10/*: any*/)
        ],
        "type": "TeamScheduleInlineRoutineOccasion",
        "abstractKey": null
      },
      {
        "kind": "InlineFragment",
        "selections": [
          (v42/*: any*/),
          (v22/*: any*/),
          (v24/*: any*/),
          (v26/*: any*/),
          (v27/*: any*/),
          (v31/*: any*/),
          (v43/*: any*/),
          (v32/*: any*/),
          (v10/*: any*/),
          (v33/*: any*/),
          (v28/*: any*/),
          (v29/*: any*/),
          (v30/*: any*/),
          (v34/*: any*/)
        ],
        "type": "RoutineOccasion",
        "abstractKey": null
      },
      (v44/*: any*/)
    ],
    "storageKey": "events(includeInlineRoutines:true)"
  },
  (v45/*: any*/)
],
v48 = {
  "kind": "Literal",
  "name": "freq",
  "value": "MONTHLY"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TeamScheduleNewQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "Team",
            "kind": "LinkedField",
            "name": "team",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "TeamScheduleComponent_team"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TeamScheduleNewQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "Team",
            "kind": "LinkedField",
            "name": "team",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "alias": "prevDailySchedule",
                "args": [
                  (v4/*: any*/),
                  (v5/*: any*/)
                ],
                "concreteType": "TeamSchedule",
                "kind": "LinkedField",
                "name": "currentTeamSchedule",
                "plural": false,
                "selections": (v6/*: any*/),
                "storageKey": "currentTeamSchedule(freq:\"DAILY\",movePeriod:-1)"
              },
              {
                "alias": "dailySchedule",
                "args": [
                  (v4/*: any*/)
                ],
                "concreteType": "TeamSchedule",
                "kind": "LinkedField",
                "name": "currentTeamSchedule",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": (v8/*: any*/),
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "events",
                    "plural": true,
                    "selections": [
                      (v9/*: any*/),
                      (v1/*: any*/),
                      (v10/*: any*/),
                      (v11/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v41/*: any*/)
                        ],
                        "type": "TeamScheduleInlineRoutineOccasion",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v42/*: any*/),
                          (v22/*: any*/),
                          (v24/*: any*/),
                          (v26/*: any*/),
                          (v27/*: any*/),
                          (v31/*: any*/),
                          (v43/*: any*/),
                          (v32/*: any*/),
                          (v33/*: any*/),
                          (v28/*: any*/),
                          (v29/*: any*/),
                          (v30/*: any*/),
                          (v34/*: any*/)
                        ],
                        "type": "RoutineOccasion",
                        "abstractKey": null
                      },
                      (v44/*: any*/)
                    ],
                    "storageKey": "events(includeInlineRoutines:true)"
                  },
                  (v45/*: any*/)
                ],
                "storageKey": "currentTeamSchedule(freq:\"DAILY\")"
              },
              {
                "alias": "prevWeeklySchedule",
                "args": [
                  (v46/*: any*/),
                  (v5/*: any*/)
                ],
                "concreteType": "TeamSchedule",
                "kind": "LinkedField",
                "name": "currentTeamSchedule",
                "plural": false,
                "selections": (v6/*: any*/),
                "storageKey": "currentTeamSchedule(freq:\"WEEKLY\",movePeriod:-1)"
              },
              {
                "alias": "weeklySchedule",
                "args": [
                  (v46/*: any*/)
                ],
                "concreteType": "TeamSchedule",
                "kind": "LinkedField",
                "name": "currentTeamSchedule",
                "plural": false,
                "selections": (v47/*: any*/),
                "storageKey": "currentTeamSchedule(freq:\"WEEKLY\")"
              },
              {
                "alias": "prevMonthlySchedule",
                "args": [
                  (v48/*: any*/),
                  (v5/*: any*/)
                ],
                "concreteType": "TeamSchedule",
                "kind": "LinkedField",
                "name": "currentTeamSchedule",
                "plural": false,
                "selections": (v6/*: any*/),
                "storageKey": "currentTeamSchedule(freq:\"MONTHLY\",movePeriod:-1)"
              },
              {
                "alias": "monthlySchedule",
                "args": [
                  (v48/*: any*/)
                ],
                "concreteType": "TeamSchedule",
                "kind": "LinkedField",
                "name": "currentTeamSchedule",
                "plural": false,
                "selections": (v47/*: any*/),
                "storageKey": "currentTeamSchedule(freq:\"MONTHLY\")"
              },
              (v1/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "053b3817b43c9baa875a4819442cdf9f",
    "id": null,
    "metadata": {},
    "name": "TeamScheduleNewQuery",
    "operationKind": "query",
    "text": "query TeamScheduleNewQuery(\n  $teamId: ID!\n) {\n  store {\n    id\n    team(id: $teamId) {\n      color\n      ...TeamScheduleComponent_team\n      id\n    }\n  }\n}\n\nfragment AHImageStackComponent_Images on Image {\n  id\n  ...Image_image\n}\n\nfragment Avatar_employee on Employee {\n  image {\n    __typename\n    ...ImagePublicOrPrivate_image\n    ... on Image {\n      id\n    }\n  }\n  workStatus\n  name\n}\n\nfragment DescriptionContentFiles_files on File {\n  id\n  url\n  ...FileCollectionItem_File\n}\n\nfragment DescriptionContentMedia_Media on Image {\n  id\n  sizes {\n    height\n    width\n    id\n  }\n  ...Image_image\n  __typename\n}\n\nfragment FileCollectionItem_File on File {\n  name\n  id\n  url\n  type\n  ...FileIcon_File\n}\n\nfragment FileIcon_File on File {\n  type\n  isOrg\n}\n\nfragment ImagePublicOrPrivate_image on PublicAndInternalImage {\n  __isPublicAndInternalImage: __typename\n  ... on PublicImage {\n    ...ImagePublic_image\n    __typename\n  }\n  ... on Image {\n    id\n    ...Image_image\n    __typename\n  }\n}\n\nfragment ImagePublic_image on PublicImage {\n  publicImageUrl\n}\n\nfragment Image_image on Image {\n  id\n  thumbhash\n  sizes {\n    id\n    url\n    urlExpiresAt\n    height\n    width\n  }\n}\n\nfragment ListItemAssignees_employees on Employee {\n  id\n  ...ListItemEmployees_employees\n}\n\nfragment ListItemAssignees_roles on EmployeeRole {\n  id\n  ...ListItemRoles_roles\n}\n\nfragment ListItemEmployees_employees on Employee {\n  id\n  name\n  isLinkedToViewer\n  workStatus\n  ...Avatar_employee\n}\n\nfragment ListItemRoles_roles on EmployeeRole {\n  id\n  name\n  isLinkedToViewer\n  employeeIds\n  team {\n    id\n  }\n  employees {\n    id\n    name\n    isLinkedToViewer\n    workStatus\n    ...Avatar_employee\n  }\n}\n\nfragment RoutineOccasionDescriptionContent_Routine on Routine {\n  descriptionImages {\n    ...DescriptionContentMedia_Media\n    id\n  }\n  description\n  descriptionFiles {\n    ...DescriptionContentFiles_files\n    id\n  }\n}\n\nfragment RoutineOccasionListItemAssignedEmployees_RoutineOccasion on RoutineOccasion {\n  assigned {\n    id\n    employee {\n      id\n      isLinkedToViewer\n      ...ListItemAssignees_employees\n    }\n    assignedAt\n  }\n  assignedRoles {\n    role {\n      ...ListItemAssignees_roles\n      id\n    }\n    id\n  }\n}\n\nfragment RoutineOccasionScreenRoutineDescription_Routine on Routine {\n  title\n  isOrg\n  ...RoutineOccasionDescriptionContent_Routine\n}\n\nfragment RoutineOccasionStatusCircleInline_RoutineOccasion on RoutineOccasion {\n  id\n  status(calculateNoTasks: true, calculateNotCompletedStarted: true)\n  deadlineAt\n  startAt\n}\n\nfragment RoutineOccasionStatusCircle_RoutineOccasion on RoutineOccasion {\n  status(calculateNoTasks: true, calculateNotCompletedStarted: true)\n  expireAt\n  deadlineAt\n  startAt\n}\n\nfragment StoreFormattedDate_1b2lNL on StoreZonedDate {\n  storeFormattedDate(style: TIME_ONLY)\n}\n\nfragment TeamScheduleComponent_team on Team {\n  color\n  prevDailySchedule: currentTeamSchedule(freq: DAILY, movePeriod: -1) {\n    id\n    notCompletedCount\n  }\n  dailySchedule: currentTeamSchedule(freq: DAILY) {\n    id\n    isActive\n    events(includeInlineRoutines: true) {\n      __typename\n      id\n      startAt\n      ...useTeamScheduleLayout_teamScheduleEventOccasion\n      ...useNowIndexes_teamScheduleEventOccasion\n      ...TeamScheduleListItem_TeamScheduleEventOccasion\n    }\n    ...TeamScheduleSectionHeaderSummary_teamSchedule\n    ...TeamScheduleSectionHeader_teamSchedule\n  }\n  prevWeeklySchedule: currentTeamSchedule(freq: WEEKLY, movePeriod: -1) {\n    id\n    notCompletedCount\n  }\n  weeklySchedule: currentTeamSchedule(freq: WEEKLY) {\n    id\n    isActive\n    events(includeInlineRoutines: true) {\n      __typename\n      id\n      ...useTeamScheduleLayout_teamScheduleEventOccasion\n      ...TeamScheduleListItem_TeamScheduleEventOccasion\n    }\n    ...TeamScheduleSectionHeaderSummary_teamSchedule\n    ...TeamScheduleSectionHeader_teamSchedule\n  }\n  prevMonthlySchedule: currentTeamSchedule(freq: MONTHLY, movePeriod: -1) {\n    id\n    notCompletedCount\n  }\n  monthlySchedule: currentTeamSchedule(freq: MONTHLY) {\n    id\n    isActive\n    events(includeInlineRoutines: true) {\n      __typename\n      id\n      ...useTeamScheduleLayout_teamScheduleEventOccasion\n      ...TeamScheduleListItem_TeamScheduleEventOccasion\n    }\n    ...TeamScheduleSectionHeader_teamSchedule\n    ...TeamScheduleSectionHeaderSummary_teamSchedule\n  }\n}\n\nfragment TeamScheduleInlineRoutineOccasionListItem_TeamScheduleInlineRoutineOccasion on TeamScheduleInlineRoutineOccasion {\n  id\n  startAt\n  taskExecution {\n    id\n    task {\n      id\n    }\n    sectionId\n    routineOccasion {\n      id\n      store {\n        myRole\n        id\n      }\n      sequenceNumber\n      notDoneStatus\n      completedTaskExecutionCount\n      totalTaskExecutionCount\n      status(calculateNoTasks: true, calculateNotCompletedStarted: true)\n      ...RoutineOccasionStatusCircleInline_RoutineOccasion\n      ...TeamScheduleRoutineListItemContent_RoutineOccasion\n      ...TeamScheduleRoutineOccasionListItemBadgeNew_routineOccasion\n      ...TeamScheduleListItemScheduleRange_routineOccasion\n    }\n    routine {\n      ...TeamScheduleRoutineListItemContent_Routine\n      id\n    }\n    checkValue\n  }\n}\n\nfragment TeamScheduleListItemMonthlyRange_routineOccasion on ScheduledOccasion {\n  __isScheduledOccasion: __typename\n  startAt\n  deadlineAt\n}\n\nfragment TeamScheduleListItemScheduleRange_routineOccasion on ScheduledOccasion {\n  __isScheduledOccasion: __typename\n  ...TeamScheduleListItemWeeklyRange_routineOccasion\n  ...TeamScheduleListItemMonthlyRange_routineOccasion\n}\n\nfragment TeamScheduleListItemTimeOfDay_TeamScheduleEventOccasion on TeamScheduleEventOccasion {\n  __isTeamScheduleEventOccasion: __typename\n  __typename\n  ... on RoutineOccasion {\n    startAtDate {\n      ...StoreFormattedDate_1b2lNL\n    }\n    deadlineAtDate {\n      ...StoreFormattedDate_1b2lNL\n    }\n  }\n  ... on TeamScheduleInlineRoutineOccasion {\n    taskExecution {\n      routineOccasion {\n        startAtDate {\n          ...StoreFormattedDate_1b2lNL\n        }\n        deadlineAtDate {\n          ...StoreFormattedDate_1b2lNL\n        }\n        id\n      }\n      id\n    }\n  }\n  ... on TeamScheduleOneOffEvent {\n    startAtDate {\n      ...StoreFormattedDate_1b2lNL\n    }\n    endAtDate {\n      ...StoreFormattedDate_1b2lNL\n    }\n  }\n}\n\nfragment TeamScheduleListItemWeeklyRange_routineOccasion on ScheduledOccasion {\n  __isScheduledOccasion: __typename\n  startAt\n  deadlineAt\n}\n\nfragment TeamScheduleListItem_TeamScheduleEventOccasion on TeamScheduleEventOccasion {\n  __isTeamScheduleEventOccasion: __typename\n  __typename\n  ...TeamScheduleListItemTimeOfDay_TeamScheduleEventOccasion\n  ... on RoutineOccasion {\n    ...TeamScheduleRoutineOccasionListItem_RoutineOccasion\n    routine {\n      id\n      isArchived\n      ...RoutineOccasionScreenRoutineDescription_Routine\n    }\n  }\n  ... on TeamScheduleInlineRoutineOccasion {\n    ...TeamScheduleInlineRoutineOccasionListItem_TeamScheduleInlineRoutineOccasion\n  }\n}\n\nfragment TeamScheduleRoutineListItemContent_Routine on Routine {\n  id\n  title\n  isOrg\n  description\n  orgIconUri\n  isArchived\n  ...RoutineOccasionScreenRoutineDescription_Routine\n  descriptionImages {\n    ...AHImageStackComponent_Images\n    id\n  }\n}\n\nfragment TeamScheduleRoutineListItemContent_RoutineOccasion on RoutineOccasion {\n  assigned {\n    employee {\n      id\n    }\n    id\n  }\n  assignedRoles {\n    role {\n      id\n    }\n    id\n  }\n  ...RoutineOccasionListItemAssignedEmployees_RoutineOccasion\n}\n\nfragment TeamScheduleRoutineOccasionListItemBadgeNew_routineOccasion on RoutineOccasion {\n  issueCount\n}\n\nfragment TeamScheduleRoutineOccasionListItem_RoutineOccasion on RoutineOccasion {\n  ...RoutineOccasionStatusCircle_RoutineOccasion\n  ...TeamScheduleRoutineListItemContent_RoutineOccasion\n  ...TeamScheduleRoutineOccasionListItemBadgeNew_routineOccasion\n  ...TeamScheduleListItemScheduleRange_routineOccasion\n  sequenceNumber\n  completedTaskExecutionCount\n  totalTaskExecutionCount\n  routine {\n    id\n    ...TeamScheduleRoutineListItemContent_Routine\n  }\n}\n\nfragment TeamScheduleSectionHeaderStatusDot_routineOccasion on RoutineOccasion {\n  status(calculateNoTasks: true, calculateNotCompletedStarted: true)\n  totalTaskExecutionCount\n}\n\nfragment TeamScheduleSectionHeaderSummaryOccasions_teamSchedule on RoutineOccasion {\n  status(calculateNoTasks: true, calculateNotCompletedStarted: true)\n  ...TeamScheduleSectionHeaderStatusDot_routineOccasion\n}\n\nfragment TeamScheduleSectionHeaderSummary_teamSchedule on TeamSchedule {\n  id\n  events(includeInlineRoutines: true) {\n    __typename\n    ... on RoutineOccasion {\n      __typename\n      ...TeamScheduleSectionHeaderSummaryOccasions_teamSchedule\n    }\n    ... on TeamScheduleInlineRoutineOccasion {\n      __typename\n      taskExecution {\n        routineOccasion {\n          ...TeamScheduleSectionHeaderSummaryOccasions_teamSchedule\n          id\n        }\n        id\n      }\n    }\n    id\n  }\n}\n\nfragment TeamScheduleSectionHeader_teamSchedule on TeamSchedule {\n  label\n  ...TeamScheduleSectionHeaderSummary_teamSchedule\n}\n\nfragment useNowIndexes_teamScheduleEventOccasion on TeamScheduleEventOccasion {\n  __isTeamScheduleEventOccasion: __typename\n  startAt\n}\n\nfragment useTeamScheduleLayout_teamScheduleEventOccasion on TeamScheduleEventOccasion {\n  __isTeamScheduleEventOccasion: __typename\n  ... on TeamScheduleInlineRoutineOccasion {\n    __typename\n    taskExecution {\n      routineOccasion {\n        __typename\n        routine {\n          description\n          descriptionImages {\n            __typename\n            id\n          }\n          id\n        }\n        assigned {\n          id\n        }\n        assignedRoles {\n          id\n        }\n        id\n      }\n      id\n    }\n  }\n  ... on RoutineOccasion {\n    __typename\n    routine {\n      description\n      descriptionImages {\n        __typename\n        id\n      }\n      id\n    }\n    assigned {\n      id\n    }\n    assignedRoles {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "aaf5551644f9b8de97e108e7a72e9c99";

export default node;
